export default __webpack_public_path__ + "static/media/the_green_room.bad27035.jpeg";